import $ from 'jquery';
import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import simpleFiledrop from 'simple-filedrop';
import 'next/stylesheets/components/comment-fake-form.scss';

Component('tr-comment-fake-form', {
  mixins: [eventListenerMixin],

  properties: {
    commentNewForm: String,
  },

  connected() {
    const dropzone = this.querySelector('.fake-textarea');

    this.listenTo(dropzone, 'click', () => {
      const form = document.querySelector(this.commentNewForm);
      if (form) form.visible = true;
    });

    this.filedrop = simpleFiledrop({
      el: $(dropzone),
      hints: '拖曳到这里上传',
    });

    this.filedrop.on('drop', this.handleDrop.bind(this));
  },

  handleDrop(_event, files) {
    if (files.length === 0) return;

    const form = document.querySelector(this.commentNewForm);
    if (!form) return;

    if (form.editor && form.editor.editorReady) {
      const { editor } = form.editor;
      editor.execute('attachmentUpload', files);
    } else {
      form.addEventListener('tao:editorReady', ({ detail }) => {
        const { editor } = detail;
        editor.execute('attachmentUpload', files);
      }, { once: true });
    }

    form.visible = true;
  },


  disconnected() {
    this.stopListening();
    this.filedrop.destroy();
  },
});
